// import dashboard from '../dashboard/dashboard.html'
(function (globals) {
    'use strict';
    globals.ROUTES = [
        /*{ "routeUrl" : "/",
          "templateUrl" : "./app/dashboard/dashboard.html",
          "controller" : "autoremind.dashboard.ScreenController",
          "permissions" : [],
 
          "navbar": "false",
          "label": "Dashboard",
          "icon": "glyphicon glyphicon-home",
          "enabled": "false",
          "dropdown": "false",
          "parent": "top"
       },*/
        { "routeUrl": "/dashboard",
            "templateUrl": "./app/dashboard/dashboard.html",
            "controller": "autoremind.dashboard.ScreenController",
            "permissions": [],
            "navbar": "true",
            "label": "Dashboard",
            "icon": "glyphicon glyphicon-home",
            "enabled": "false",
            "dropdown": "false",
            "parent": "top"
        },
        { "routeUrl": "/communications",
            "templateUrl": "app/communication/communications.html",
            "controller": "autoremind.communications.ScreenController",
            "permissions": [{ "key": "communication" }],
            "navbar": "true",
            "label": "Communications",
            "icon": "glyphicon glyphicon-briefcase",
            "enabled": "true",
            "dropdown": "false",
            "parent": "top"
        },
        { "routeUrl": "/reports/:type?",
            "menu": "/reports/",
            "templateUrl": "app/reports/reports.html",
            "controller": "autoremind.reports.ScreenController",
            "permissions": [{ "key": "autoremind3" }, { "key": "communication" }],
            "navbar": "true",
            "label": "Reports",
            "icon": "glyphicon glyphicon-file",
            "enabled": "true",
            "dropdown": "false",
            "parent": "top"
        },
        { "routeUrl": "/two-way",
            "permissions": [{ "key": "twoway" }],
            "navbar": "true",
            "label": "Two-Way",
            "icon": "glyphicon glyphicon-retweet",
            "enabled": "true",
            "dropdown": "false",
            "parent": "top"
        },
        { "routeUrl": "/csv",
            "templateUrl": "app/csv/csv.html",
            "controller": "autoremind.csv.ScreenController",
            "permissions": [{ "key": "csv:practicechoice" },
                { "page": "csvpracticechoice" },
                { "username": "PrimaryCareAssociates" },
                { "username": "AdvancedFamilyCare" },
                { "username": "progressivewomenshealth" },
                { "username": "ProgressiveBehavioralHealth" }],
            "navbar": "true",
            "label": "Practice Choice",
            "icon": "glyphicon glyphicon-upload",
            "enabled": "true",
            "dropdown": "false",
            "parent": "top"
        },
        { "routeUrl": "/csvuspi",
            "templateUrl": "app/csv/csvuspi.html",
            "controller": "autoremind.csv.ScreenController",
            "permissions": [{ "key": "csv:uspi" },
                { "page": "csvuspi" },
                { "username": "desertridge" },
                { "type": "portal", "address": "csv_uspi" }],
            "navbar": "true",
            "label": "USPI Import",
            "icon": "glyphicon glyphicon-upload",
            "enabled": "true",
            "dropdown": "false",
            "parent": "top"
        },
        { "routeUrl": "/csv_webselfstorage",
            "templateUrl": "app/csv/csv_webselfstorage.html",
            "controller": "autoremind.csv.ScreenController",
            "permissions": [{ "key": "csv:webselfstorage" },
                { "page": "csvwebselfstorage" },
                { "username": "webselfstorage" },
                { "username": "WestChesterMasonStoreandLock" }],
            "navbar": "true",
            "label": "StorageReminder",
            "icon": "glyphicon glyphicon-upload",
            "enabled": "true",
            "dropdown": "false",
            "parent": "top"
        },
        { "routeUrl": "/csvederm",
            "templateUrl": "app/csv/csvederm.html",
            "controller": "autoremind.csv.ScreenController",
            "permissions": [{ "key": "csv:ederm" },
                { "page": "csvederm" },
                { "username": "ConnecticutRiverValley" }],
            "navbar": "true",
            "label": "eDerm Import",
            "icon": "glyphicon glyphicon-upload",
            "enabled": "true",
            "dropdown": "false",
            "parent": "top"
        },
        { "routeUrl": "/csvlatepayment",
            "templateUrl": "app/csv/csvlatepayment.html",
            "controller": "autoremind.csv.ScreenController",
            "permissions": [{ "key": "csv:latepayment" }],
            "navbar": "true",
            "label": "Late Payment",
            "icon": "glyphicon glyphicon-upload",
            "enabled": "true",
            "dropdown": "false",
            "parent": "top"
        },
        { "routeUrl": "/profile",
            "templateUrl": "app/profile/profile.html",
            "controller": "autoremind.profile.ScreenController",
            "permissions": [],
            "navbar": "true",
            "label": "My Profile",
            "icon": "glyphicon glyphicon-user",
            "enabled": "true",
            "dropdown": "false",
            "parent": "/profile"
        },
        // { "routeUrl" : "/satellites",
        //     "templateUrl" : "app/satellites/satellites.html",
        //     "controller" : "autoremind.satellites.ScreenController",
        //     "permissions" : [{"key" : "autoremind3"}],
        //     "navbar": "true",
        //     "label": "Client Satellite Setup",
        //     "icon": "glyphicon glyphicon-cog",
        //     "enabled": "true",
        //     "dropdown": "false",
        //     "parent": "/profile",
        //     "loginFromAdmin": "true"
        // },
        /*
        { "routeUrl" : "/support",
            "templateUrl" : "app/support/support.html",
            "controller" : "autoremind.support.ScreenController",
            "permissions" : [ ],
            "navbar": "false",
            "label": "Support",
            "icon": "glyphicon glyphicon-question-sign",
            "enabled": "true",
            "dropdown": "false",
            "parent": "/profile"
        },
        */
        /*{ "routeUrl" : "/inspire",
            "templateUrl" : "app/news/news.html",
            "controller" : "autoremind.news.ScreenController",
            "permissions" : [],
            "navbar": "true",
            "label": "Inspire",
            "icon": "inspire-icon",
            "enabled": "true",
            "dropdown": "false",
            "parent": "/profile"
        },*/
        { "routeUrl": "/users",
            "routeAlt": "/admin/users",
            "templateUrl": "app/admin/users/users.html",
            "controller": "autoremind.users.ScreenController",
            "permissions": [{ "key": "access" }],
            "navbar": "true",
            "id": "users",
            "label": "Users",
            "icon": "glyphicon glyphicon-user",
            "enabled": "true",
            "dropdown": "false",
            "parent": "sidebar",
            "sidebar": "group"
        },
        { "routeUrl": "/admin/users/find/:tabname?",
            "menu": "/admin/users/find/",
            "templateUrl": "app/admin/users/users.html",
            "controller": "autoremind.users.ScreenController",
            "permissions": [{ "key": "access" }],
            "navbar": "false",
            "label": "Find",
            "icon": "glyphicon glyphicon-user",
            "enabled": "true",
            "dropdown": "false",
            "parent": "users",
            "sidebar": "/admin/users"
        },
        { "routeUrl": "/admin/users/new",
            "templateUrl": "app/admin/users/users.html",
            "controller": "autoremind.users.ScreenController",
            "permissions": [{ "key": "access" }],
            "navbar": "false",
            "label": "New",
            "icon": "glyphicon glyphicon-user",
            "enabled": "true",
            "dropdown": "false",
            "parent": "users",
            "sidebar": "/admin/users"
        },
        { "routeUrl": "/admin/permissions",
            "templateUrl": "app/permissions/permissions.html",
            "controller": "autoremind.users.ScreenController",
            "permissions": [{ "key": "access" }],
            "navbar": "false",
            "label": "Permissions",
            "icon": "glyphicon glyphicon-cog",
            "enabled": "true",
            "dropdown": "false",
            "parent": "/users",
            "sidebar": "/admin/users"
        },
        { "routeUrl": "/admin/templates",
            "templateUrl": "app/admin/templates/templates.autoremind3.html",
            "controller": "autoremind.users.templatesController",
            "permissions": [{ "key": "admin" }],
            "navbar": "true",
            "id": "templates",
            "label": "Templates",
            "icon": "glyphicon glyphicon-asterisk",
            "enabled": "true",
            "dropdown": "false",
            "sidebar": "group"
        },
        { "routeUrl": "/admin/templates/autoremind3",
            "templateUrl": "app/admin/templates/templates.autoremind3.html",
            "controller": "autoremind.users.templatesController",
            "permissions": [{ "key": "admin" }],
            "navbar": "false",
            "id": "autoremind3",
            "label": "Autoremind 3",
            "icon": "glyphicon glyphicon-user",
            "enabled": "true",
            "dropdown": "false",
            "sidebar": "/admin/templates/autoremind3"
        },
        { "routeUrl": "/admin/misc",
            "templateUrl": "",
            "controller": "",
            "permissions": [{ "key": "admin" }],
            "navbar": "true",
            "id": "misc",
            "label": "Misc",
            "icon": "glyphicon glyphicon-cog",
            "enabled": "true",
            "dropdown": "false",
            "sidebar": "group"
        },
        { "routeUrl": "/admin/messaging",
            "templateUrl": "app/admin/messaging/messaging.html",
            "controller": "autoremind.messaging.ScreenController",
            "permissions": [{ "key": "admin" },
                { "username": "botest" },
                { "username": "systemtest" }],
            "navbar": "true",
            "label": "Messaging",
            "icon": "glyphicon glyphicon-hdd",
            "enabled": "true",
            "dropdown": "false",
            "parent": "/admin/misc",
            "sidebar": "/admin/misc"
        },
        { "routeUrl": "/admin/chargify/:tabname?",
            "menu": "/admin/chargify",
            "templateUrl": "app/admin/chargify/chargify.html",
            "controller": "autoremind.admin.chargify.ScreenController",
            "permissions": [{ "key": "admin" }],
            "navbar": "true",
            "label": "Chargify",
            "icon": "glyphicon glyphicon-hdd",
            "enabled": "true",
            "dropdown": "false",
            "parent": "/admin/misc",
            "sidebar": "/admin/misc"
        },
        { "routeUrl": "/admin/satellites/:tabname?",
            "templateUrl": "app/admin/satellites/satellites.html",
            "controller": "autoremind.satellites.ScreenController",
            "permissions": [{ "key": "admin" }],
            "navbar": "true",
            "label": "Satellites",
            "icon": "glyphicon glyphicon-cog",
            "enabled": "true",
            "dropdown": "false",
            "parent": "/admin/misc",
            "sidebar": "/admin/misc"
        },
        { "routeUrl": "/admin/system",
            "permissions": [{ "key": "admin" }],
            "navbar": "true",
            "label": "System",
            "icon": "glyphicon",
            "enabled": "true",
            "dropdown": "false",
            "parent": "/admin/misc",
            "sidebar": "/admin/misc"
        },
        { "routeUrl": "/admin/queries",
            "templateUrl": "app/admin/queries/queries.html",
            "controller": "autoremind.queries.ScreenController",
            "permissions": [{ "key": "admin" }],
            "navbar": "true",
            "label": "Queries",
            "icon": "glyphicon glyphicon-eye-open",
            "enabled": "true",
            "dropdown": "false",
            "parent": "/admin/misc",
            "sidebar": "/admin/misc"
        },
        { "routeUrl": "/dev/test",
            "templateUrl": "app/dev/test.html",
            "controller": "autoremind.dev.test.ScreenController",
            "permissions": [{ "key": "admin" }],
            "navbar": "false",
            "label": "HTTP Tester",
            "icon": "glyphicon glyphicon-cog",
            "enabled": "true",
            "dropdown": "false",
            "parent": "/profile"
        }
    ];
}(window));
//# sourceMappingURL=routes.js.map